const messages = {
    en: {
        delivery: {
            contact: 'Contact',
            payment: 'Payment',
            destination: 'Destination',
            orderPayment: 'Order payment',
            orderPaymentDescription: '',
            dataOrderConfirm: 'Confirm orderSystem data',
            orderConfirm: 'Confirm orderSystem',
            orderConfirmTransfer: 'Confirm orderSystem',
            orderReview: 'Order review',
            orderReviewDescription: 'Please, check that your data and orderSystem are correct',
            checkAndConfirm: 'Order confirmation',
            checkAndConfirmDescription: 'Please, check that your data and orderSystem are correct',
            myOrder: 'My orderSystem',
            orderView: 'Order #{identifier}',
            emptyOrder: 'Your orderSystem is empty',
            schedule: 'Schedule',
            table: 'Table',
            date: 'Date',
            noPendingOrders: '',
            createdAt: 'Created At',
            updatedAt: 'Updated At',
            scheduleTime: {
                noOptions: 'No schedules available'
            },
            shift:{
                morning: 'Morning',
                afternoon: 'Afternoon'
            },
            print: "Print"


        }
    },
    es: {
        delivery: {
            contact: 'Contacto',
            payment: 'Pago',
            destination: 'Destino',
            orderPayment: '¿Cómo querés pagar?',
            orderPaymentDescription: '',
            dataOrderConfirm: 'Confirmar datos del pedido',
            orderConfirm: 'Confirmar pedido',
            orderConfirmTransfer: 'Confirmar y Transferir',
            orderReview: 'Revisión del pedido',
            orderReviewDescription: 'Por favor, revisá que tus datos y pedido esten bien',
            checkAndConfirm: 'Confirmación de pedido',
            checkAndConfirmDescription: 'Por favor, revisá que tus datos y pedido esten bien',
            myOrder: 'Pedido',
            orderView: 'Orden #{identifier}',
            emptyOrder: 'Su pedido esta vacío',
            schedule: 'Horario', //Horario
            table: 'Mesa',
            date: 'Fecha',
            createdAt: 'Fecha creación',
            updatedAt: 'Ultima Actualización',
            scheduleTime: {
                noOptions: 'Sin horarios disponibles'
            },
            shift:{
                morning: 'Mañana',
                afternoon: 'Tarde'
            },
            print: "Imprimir"


        }
    },
    pt: {
        delivery: {
            contact: 'Contato',
            payment: 'Pago',
            destination: 'Destino',
            orderPayment: 'Order payment',
            orderPaymentDescription: '',
            dataOrderConfirm: 'Confirmar datos del pedido',
            orderConfirm: 'Confirmar pedido',
            orderConfirmTransfer: 'Confirm orderSystem',
            orderReview: 'Revisión del pedido',
            orderReviewDescription: 'Por favor, revisá que tus datos y pedido esten bien',
            checkAndConfirm: 'Confirmación de pedido',
            checkAndConfirmDescription: 'Por favor, revisá que tus datos y pedido esten bien',
            myOrder: 'O meu pedido',
            orderView: 'Pedido #{identifier}',
            emptyOrder: 'seu pedido está vazio',
            schedule: 'Cronograma', //Horario
            table: 'Table',
            date: 'Date',
            createdAt: 'Created At',
            updatedAt: 'Updated At',
            scheduleTime: {
                noOptions: 'Sem horários disponíveis'
            },
            shift:{
                morning: 'Morning',
                afternoon: 'Afternoon'
            },
            print: "Print"

        }
    }
}

export default messages
